import axios from "axios";
import { Config } from "../Config";

class ApiInstance {
  public getApi() {
    return axios.create({
      baseURL: Config.getBackendUrl(),
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
    });
  }
}

const apiInstance = new ApiInstance();
export default apiInstance;
